import YandexMetrikaProtocol from './protocols/YandexMetrikaProtocol';
import ClickstreamProtocol from './protocols/ClickstreamProtocol';
import OneDMPProtocol from './protocols/OneDMPProtocol';
import CustomRelay from './CustomRelay';
import {
    ProtocolTypes,
    iMetricsService,
    RealEventsMap,
} from '@/modules/Metrix/types';
import { RuntimeEventData } from '@/app/modules/Metrics/types';

/**
 * Сервис централизованной работы с метриками в авторизации
 */
export default class DefaultMetrixService implements iMetricsService {
    protected readonly relay: CustomRelay;

    constructor() {
        this.relay = new CustomRelay();

        this.relay.registerProtocolHandler(
            new YandexMetrikaProtocol(ProtocolTypes.YMETRIKA)
        );
        this.relay.registerProtocolHandler(
            new ClickstreamProtocol(ProtocolTypes.CSC)
        );
        this.relay.registerProtocolHandler(
            new OneDMPProtocol(ProtocolTypes.ONEDMP)
        );
    }

    public registerEvents(events: RealEventsMap) {
        this.relay.addEvents(events);
    }

    public transmit(event: string, customValue?: RuntimeEventData) {
        this.relay.transmit(event, customValue);
    }
}
